import PaymentSuccess from "./PaymentSuccess";

export default PaymentSuccess;
